import * as React from 'react'

import type {
  CardClosingRequirements,
  ENTITY_TYPES,
} from '@sales-center/common'

import { AnimationHandler } from './atoms'
import { AppointmentsTable } from './AppointmentsTable'
import { PaymentsTable } from './PaymentsTable'
import { AgreementsTable } from './AgreementsTable'
import { IForm } from '@user/store/agreements'

type Props = {
  billToId: string
  canUpdate: boolean
  entityId: number
  entityClosed: boolean
  entityType: ENTITY_TYPES
  externalLocationId: string
  requirementsAndCounts: CardClosingRequirements
  openAgreementCreateDrawer?: (formData?: IForm) => void
}

export function ClosingRequirementsTableList(props: Props) {
  return (
    <>
      <AnimationHandler requirement="agreement">
        <AgreementsTable {...props} />
      </AnimationHandler>

      <AnimationHandler requirement="payment">
        <PaymentsTable {...props} />
      </AnimationHandler>

      <AnimationHandler requirement="scheduling">
        <AppointmentsTable {...props} />
      </AnimationHandler>
    </>
  )
}
